module.exports = __webpack_public_path__ + "img/Ardunic Account page-444.cb8f1e97.svg";